import { render, staticRenderFns } from "./history_list.vue?vue&type=template&id=60ecbb0a&scoped=true&lang=pug&"
import script from "./history_list.vue?vue&type=script&lang=js&"
export * from "./history_list.vue?vue&type=script&lang=js&"
import style0 from "./history_list.vue?vue&type=style&index=0&id=60ecbb0a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ecbb0a",
  null
  
)

export default component.exports